import { parsePhoneNumberFromString as parseNumber } from 'libphonenumber-js';

export const formatPhoneNumber = (phoneNumberString) => {
  const parsed = parseNumber(`+${phoneNumberString}`);
  if (parsed) {
    return parsed.formatInternational();
  } else {
    return phoneNumberString;
  }
};

export const formatExtension = (extension, extensionText) => {
  if (extension) {
    return ` ${extensionText} ${extension}`;
  }
};
